import toast from 'react-hot-toast';

export const showSuccessToast = (message: string, options?: any) => {
  return toast.success(message, {
    position: 'top-right',
    duration: 2000,
    style: {
      background: '#4CAF50',
      color: 'white',
      border: '1px solid #4CAF50',
    },
    ...options
  });
};

export const showErrorToast = (message: string, options?: any) => {
  return toast.error(message, {
    position: 'top-right',
    duration: 2000,
    style: {
      background: '#F44336',
      color: 'white',
      border: '1px solid #F44336',
    },
    ...options
  });
};

export const showInfoToast = (message: string, options?: any) => {
  return toast(message, {
    position: "top-right",
    duration: 2000,
    style: {
      background: "#2196F3",
      color: "white",
      border: "1px solid #2196F3",
    },
  });
};